const fetchAccountGroupPermissionsRepository = (axios) => async (id) => {
    try {
        const response = await axios.get(`/account-group/${id}/permission`)
        return response.data
    } catch (err) {
        throw err
    }
}

export default fetchAccountGroupPermissionsRepository